module.exports = __webpack_public_path__ + "static/media/defrost.c6148630.png";